import services from '@/services/ascentiaServiceIndex'
import { SUBSCRIPTION_CENTER_CONSTS as SCC } from '../consts'

const state = {
  subscriptions: [],
  subscriptionsTypes: [],
  subscriptionsLoading: false,
  analyticSystems: [],
}

const getters = {
  mappedAnalyticSystemsGroupedWithAirlines() {
    if (state.analyticSystems && state.analyticSystems.length) {
      const systems = []
      state.analyticSystems.forEach(item => {
        const systemIndex = systems.findIndex(
          system => system.value === item.systemKey,
        )

        if (systemIndex > -1) {
          systems[systemIndex].items.push({
            value: item.airlineIcaoCode,
            text: item.airlineName,
            airlineIcaoCode: item.airlineIcaoCode,
          })
        } else {
          systems.push({
            value: item.systemKey,
            text: item.text,
            items: [
              {
                value: item.airlineIcaoCode,
                text: item.airlineName,
                airlineIcaoCode: item.airlineIcaoCode,
              },
            ],
          })
        }
      })
      return systems
    }
    return []
  },
  mappedAirlineGroupedWithAtaChapter: (
    state,
    getters,
    rootState,
    rootGetters,
  ) => {
    const mappedLuAtaChapters = rootGetters['lookups/mappedLuAtaChapters']

    if (
      state.analyticSystems &&
      state.analyticSystems.length &&
      mappedLuAtaChapters &&
      mappedLuAtaChapters.length
    ) {
      const airlines = []
      state.analyticSystems.forEach(item => {
        const airlineIndex = airlines.findIndex(
          airline => airline.value === item.airlineIcaoCode,
        )
        if (airlineIndex === -1) {
          let data = {
            value: item.airlineIcaoCode,
            text: item.airlineName,
            airlineIcaoCode: item.airlineIcaoCode,
            items: mappedLuAtaChapters.map(ataChapter => {
              return {
                value: `${ataChapter.value}`,
                text: ataChapter.text,
              }
            }),
          }
          airlines.push(data)
        }
      })
      return airlines
    }
    return []
  },
  mappedAtaChapterGroupedWithAirlines: (
    state,
    getters,
    rootState,
    rootGetters,
  ) => {
    const mappedLuAtaChapters = rootGetters['lookups/mappedLuAtaChapters']

    if (
      state.analyticSystems &&
      state.analyticSystems.length &&
      mappedLuAtaChapters &&
      mappedLuAtaChapters.length
    ) {
      let ataChapter = []
      mappedLuAtaChapters.forEach(ataChap => {
        state.analyticSystems.forEach(item => {
          const ataChapterIndex = ataChapter.findIndex(
            ataChapter => ataChapter.value === `${ataChap.value}`,
          )
          if (ataChapterIndex > -1) {
            if (
              !ataChapter[ataChapterIndex].items.find(
                f => f.value === item.airlineIcaoCode,
              )
            )
              ataChapter[ataChapterIndex].items.push({
                value: item.airlineIcaoCode,
                text: item.airlineName,
                airlineIcaoCode: item.airlineIcaoCode,
              })
          } else {
            ataChapter.push({
              value: `${ataChap.value}`,
              text: ataChap.text,
              items: [
                {
                  value: item.airlineIcaoCode,
                  text: item.airlineName,
                  airlineIcaoCode: item.airlineIcaoCode,
                },
              ],
            })
          }
        })
      })
      return ataChapter
    }
    return []
  },
  mappedAirlinesGroupedWithAnalyticSystems(state) {
    if (state.analyticSystems && state.analyticSystems.length) {
      const airlines = []
      state.analyticSystems.forEach(item => {
        const airlineIndex = airlines.findIndex(
          airline => airline.value === item.airlineIcaoCode,
        )

        if (airlineIndex > -1) {
          airlines[airlineIndex].items.push({
            value: item.systemKey,
            text: item.text,
          })
        } else {
          airlines.push({
            value: item.airlineIcaoCode,
            text: item.airlineName,
            airlineIcaoCode: item.airlineIcaoCode,
            items: [{ value: item.systemKey, text: item.text }],
          })
        }
      })
      return airlines
    }
    return []
  },
}

const mutations = {
  [SCC.UPDATE_SUBSCRIPTIONS]: (state, data) => (state.subscriptions = data),
  [SCC.SUBSCRIPTIONS_LOADING]: (state, data) =>
    (state.subscriptionsLoading = data),
  [SCC.UPDATE_SUBSCRIPTIONS_TYPES]: (state, data) =>
    (state.subscriptionsTypes = data),
  [SCC.UPDATE_ANALYTIC_SYSTEMS]: (state, data) =>
    (state.analyticSystems = data),
}

const actions = {
  async [SCC.GET_SUBSCRIPTIONS_TYPES]({ commit }, subscribable = true) {
    try {
      commit(SCC.SUBSCRIPTIONS_LOADING, true)
      const response = await services.subscriptionCenter.getData(
        'emailSubscriptionsTypes',
        subscribable,
      )
      commit(SCC.UPDATE_SUBSCRIPTIONS_TYPES, response.data)
      commit(SCC.SUBSCRIPTIONS_LOADING, false)
    } catch (error) {
      console.log(`${[SCC.GET_SUBSCRIPTIONS_TYPES]}: error ${error}`)
    }
  },
  async [SCC.GET_SUBSCRIPTIONS](
    { commit },
    subscriptionIds = [],
    args = { refresh: true },
  ) {
    try {
      commit(SCC.SUBSCRIPTIONS_LOADING, true)
      const response = await services.subscriptionCenter.getData(
        'emailSubscriptions',
        subscriptionIds,
        args.refresh,
      )
      commit(SCC.UPDATE_SUBSCRIPTIONS, response.data)
      commit(SCC.SUBSCRIPTIONS_LOADING, false)
    } catch (error) {
      console.log(`${[SCC.GET_SUBSCRIPTIONS]}: error ${error}`)
    }
  },
  async [SCC.SAVE_SUBSCRIPTIONS]({ commit }, subscriptions) {
    try {
      commit(SCC.SUBSCRIPTIONS_LOADING, true)
      await services.subscriptionCenter
        .saveData('emailSubscriptions', subscriptions)
        .then(resp => {
          if (resp instanceof Error) return Promise.reject(resp)
          // need to loop through each response object to
          // get the newly created ID  (only returning from a POST) out of the URL and match up the data
          const savedSubscriptions = resp.map(responseObj => {
            const subscriptionData = JSON.parse(responseObj.config.data)
            return {
              ...subscriptionData,
              isNew: false,
            }
          })
          commit(SCC.UPDATE_SUBSCRIPTIONS, savedSubscriptions)
          return Promise.resolve(resp)
        })
        .catch(error => {
          console.log(`${[SCC.SAVE_SUBSCRIPTIONS]}: error ${error}`)
        })
      commit(SCC.SUBSCRIPTIONS_LOADING, false)
    } catch (error) {
      console.log(`${[SCC.SAVE_SUBSCRIPTIONS]}: error ${error}`)
    }
  },
  async [SCC.UPDATE_SUBSCRIPTION]({ commit }, subscriptions) {
    try {
      commit(SCC.SUBSCRIPTIONS_LOADING, true)
      await services.subscriptionCenter
        .saveData('emailSubscriptions', subscriptions)
        .then(resp => {
          if (resp instanceof Error) return Promise.reject(resp)
          return Promise.resolve(resp)
        })
        .catch(error => {
          console.log(`${[SCC.UPDATE_SUBSCRIPTION]}: error ${error}`)
        })
      commit(SCC.SUBSCRIPTIONS_LOADING, false)
    } catch (error) {
      console.log(`${[SCC.UPDATE_SUBSCRIPTION]}: error ${error}`)
    }
  },
  async [SCC.GET_ANALYTIC_SYSTEMS]({ commit }) {
    try {
      const response = await services.analytic.getData('analyticSystems')
      const data = response.data.map(item => {
        return {
          value: item.systemId,
          text: item.systemName,
          systemKey: item.systemKey,
          airlineId: item.airlineId,
          airlineIcaoCode: item.icaoCode,
          airlineName: item.airlineName,
        }
      })

      commit(SCC.UPDATE_ANALYTIC_SYSTEMS, data)
    } catch (error) {
      console.log(`${SCC.GET_ANALYTIC_SYSTEMS}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
